module.exports = __webpack_public_path__ + "img/22_4.024a011e.png";